<template>
  <button class="btn" :class="cssType + ' ' + props.type + ' ' + (props.disabled ? 'disabled' : '') + ' ' + locale">
    <span class="btn-inner">
      <slot></slot>
    </span>
  </button>
</template>
<script setup>
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  type: {
    type: String,
    default: 'blue', // blue green
  },
  disabled: {
    type: Boolean,
    default: false,
  }
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>